<mat-card>
  <mat-card-header>
    <mat-card-title>Comunicados</mat-card-title>
  </mat-card-header>

  <mat-card-content>
    @if (isLoading) {
      <div class="loading-container">
        <mat-spinner diameter="40"></mat-spinner>
      </div>
    }

    @if (error) {
      <div class="error-container">
        <p>Erro ao carregar comunicados</p>
      </div>
    }

    @if (!isLoading && !error) {
      <div class="communication-list">
        @for (communication of communications; track communication) {
          <app-communication-summary-tile
            [communication]="communication">
          </app-communication-summary-tile>
        }
        @if (communications.length === 0) {
          <div class="empty-state">
            <p>Nenhum comunicado encontrado</p>
          </div>
        }
      </div>
    }
  </mat-card-content>

  <mat-card-actions align="end" class="button-spacing">
    <button mat-raised-button color="accent" routerLink="/condominium/{{condominiumId}}/communications">
      Ver todos
    </button>
  </mat-card-actions>
</mat-card>
